import React, { useEffect, useRef, useState } from 'react'
import { toggle } from 'slidetoggle'
import { declOfNum } from '../../utils/helpers'
import { MyWorkType } from '../../containers/ProfileContestsWorkPage/types'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from '../../containers/SignInPage/types'
import * as actionsProfile from '../../containers/SignInPage/actions'
import moment from 'moment'

// Styles
import './styles.scss'

// Icons
import IconOpen from '../../containers/ProfileContestsPage/images/iconOpen'
import IconCup from './images/iconCup'
import ImageTree from './images/imageTree'
import IconCheck from './images/iconCheck'

export default ({ item }: { item: MyWorkType }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const dispatch = useDispatch()

  const { viewedContestWorks } = useSelector(
    (state: { profile: InitialState }) => state.profile
  )

  const isMounted = useRef<boolean>(false)
  const refContent = useRef<HTMLDivElement | null>(null)

  const isViewed =
    Array.isArray(viewedContestWorks) &&
    viewedContestWorks.includes(item.user_contest_id)

  useEffect(() => {
    if (isMounted.current && refContent.current) {
      toggle(refContent.current, {
        miliseconds: 500,
        transitionFunction: 'ease-in',
      })
    }
  }, [isOpen])

  useEffect(() => {
    isMounted.current = true
  }, [])

  const toggleBlock = () => {
    setIsOpen(!isOpen)
    if (!isViewed) {
      dispatch(actionsProfile.setViewedContestWork(item.user_contest_id))
    }
  }

  const getValue = (code: string): string => {
    const fieldId = item.answers.find(
      field => field.contest_field.code === code
    )?.contest_field_id
    const fieldValue = item.answers.find(
      field => field.contest_field_id === fieldId
    )?.value
    return fieldValue || ''
  }

  const getCheckboxes = (): string[] => {
    const checkboxes: string[] = []
    item.answers
      .filter(answer => answer.contest_field.type === 'boolean')
      .forEach(answer => {
        checkboxes.push(answer.contest_field.caption)
      })
    return checkboxes
  }

  const itemClasses = [
    isViewed && 'viewed',
    isOpen && 'opened',
    'database-item',
  ]

  const age = item.user.profile.birthdate
    ? moment().diff(item.user.profile.birthdate, 'years')
    : 0

  return (
    <div className={itemClasses.join(' ')}>
      <div className={'database-item__header'}>
        <div className={'database-item__info'}>
          <div className={'database-item__info-row'}>
            <span className={'database-item__info-name'}>{item.title}</span>
            {item.status === 'winner' ? <IconCup /> : null}
            {item.avg_score ? (
              <div className={'scores'}>
                <div className={'scores__value'}>{item.avg_score}</div>
                <span className={'scores__text'}>баллов</span>
              </div>
            ) : null}
          </div>
          <div className={'database-item__info-author'}>
            {age ? (
              <div className={'database-item__info-age'}>
                {`${age} ${declOfNum(age, ['год', 'года', 'лет'])}`}
              </div>
            ) : null}
            <span>
              Автор — {item.user.profile.first_name}{' '}
              {item.user.profile.last_name}
            </span>
          </div>
          <div className={'database-item__info-description'}>
            <span>{getValue('essence')}</span>
          </div>
        </div>
        <button onClick={toggleBlock} className={'database-item__button'}>
          <IconOpen style={{ marginRight: 28 }} />
          {isOpen ? 'Свернуть' : 'Развернуть'}
        </button>
      </div>
      <div ref={refContent} className="database-item__content">
        <div className={'database-item__content-description'}>
          {getValue('essence')}
        </div>
        <div className={'database-item__content-info'}>
          <div className={'row'}>
            <div className={'row__item'}>
              <div className="field">
                <div className="field__label">Регион:</div>
                <div className="field__input">
                  {item.user_region.region || 'Не заполнен'}
                </div>
              </div>
              <div className="field">
                <div className="field__label">Населенный пункт:</div>
                <div className="field__input">
                  {item.user_region.location || 'Не заполнен'}
                </div>
              </div>
              <div className={'persons'}>
                <ImageTree />
                <div className={'persons__counter'}>
                  {getValue('number_of_persons') || 0}
                </div>
                <span className={'persons__text'}>
                  Персон в древе
                  <br />
                  участника
                </span>
              </div>
            </div>
            <div className={'row__item'}>
              <div className="field">
                <div className="field__label">Образовательное учреждение:</div>
                <div className="field__input">
                  {item.user.profile.school?.value}
                </div>
              </div>
              <div className="field">
                <div className="field__label">
                  Упомянутые населенные пункты в работе:
                </div>
                <div
                  className="field__input"
                  dangerouslySetInnerHTML={{
                    __html: getValue('territories').replace(/,/g, '<br>'),
                  }}
                />
              </div>
              <div className="field last">
                <div className="field__label">В том числе фамилии:</div>
                <div
                  className="field__input"
                  dangerouslySetInnerHTML={{
                    __html: getValue('last_names').replace(/\n/g, '<br>'),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={'database-item__content-years'}>
          <div className={'year'}>
            <div className={'year__circle'} />
            <span className={'year__text'}>
              {getValue('first_mention') || 0}
            </span>
          </div>
          <div className="line" />
          <div className={'year'}>
            <div className={'year__circle'} />
            <span className={'year__text'}>2021</span>
          </div>
        </div>
        <div className={'database-item__content-opening'}>
          {getCheckboxes().length ? (
            <div className={'row'}>
              <div className={'row__item'}>
                {getCheckboxes()
                  .filter((_, idx) => idx % 2 !== 0)
                  .map((checkbox, idx) => (
                    <div key={`left-checkbox-${idx}`} className={'option'}>
                      <IconCheck />
                      <span>{checkbox}</span>
                    </div>
                  ))}
              </div>
              <div className={'row__item'}>
                {getCheckboxes()
                  .filter((_, idx) => idx % 2 === 0)
                  .map((checkbox, idx) => (
                    <div key={`right-checkbox-${idx}`} className={'option'}>
                      <IconCheck />
                      <span>{checkbox}</span>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <p className={'incredible'}>{getValue('did_incredible')}</p>
          )}
        </div>
      </div>
    </div>
  )
}
